import { useCallback, useState } from "react"
import { Autocomplete, InputAdornment, TextField } from "@mui/material"
import { isEmpty } from "lodash"
import Image from "next/image"
import useLocalStorage from "@/hooks/useLocalStorage"
import SearchIcon from "@/assets/icons/search.svg"

interface SearchInputProps {
  placeholder?: string
  handleSearchText: (text: string) => void
}

const SearchInput = (props: SearchInputProps) => {
  const { placeholder, handleSearchText } = props
  const [inputSearch, setInputSearch] = useState("")
  const [searchCache, setSearchCache] = useLocalStorage<Array<string>>("search_nft", [])

  const myOptions: Array<string> = searchCache.reverse()

  const filterData = useCallback(
    (e: any) => {
      setInputSearch(e.target.value)
    },
    [setInputSearch],
  )

  const handleSearch = useCallback(
    (e: any, v: any) => {
      const value = isEmpty(v) ? "" : v
      setInputSearch(value)
      handleSearchText(value)

      // cache
      if (!searchCache.includes(value) && value !== "") {
        searchCache.unshift(value)
        setSearchCache(searchCache.splice(0, 15))
      }
    },
    [handleSearchText, setSearchCache, searchCache],
  )

  return (
    <Autocomplete
      data-testid='search-ntf-input'
      freeSolo
      autoComplete
      autoHighlight
      inputValue={inputSearch}
      options={myOptions}
      onChange={handleSearch}
      fullWidth
      renderInput={(params) => (
        <TextField
          {...params}
          size='small'
          sx={{
            "& .MuiInputBase-root": {
              borderRadius: "0.5rem",
            },
            "& MuiOutlinedInput-root": {
              padding: "11px 8px",
            },
          }}
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <InputAdornment position='end'>
                <Image src={SearchIcon} height={17} alt='search-icon' />
              </InputAdornment>
            ),
          }}
          onChange={filterData}
          variant='outlined'
          placeholder={placeholder}
        />
      )}
    />
  )
}

export default SearchInput
